import { DISTRIBUTION_URL } from "../../../services/common-urls";
import { JSON_STRING, MHTTPCL  } from "../../../services/http/http-client";

const SECTION = "reports"

export const DistributionReleaseReportService ={
    
    releaseReportTab:()=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SECTION,
        action	:"releaseReportTab",
        output:JSON_STRING
    }),

    filterReleases:({str='' ,artist='' ,release_type='',status ='' ,label_id='',start=0})=>MHTTPCL.post(DISTRIBUTION_URL,{
        section	:SECTION,
        action	:"filter_releases",
        str	:str,
        artist	:artist,
        release_type	:release_type,
        status	:status,
        label_id :	label_id,
        start :	start,
        output:JSON_STRING
    })
   
}
